module.exports = function getResource(label, vars = []) {
    let resources = {
        shippingAndHandling: 'Expédition et manutention',
        discounts: 'Réductions',
        giftWrap: 'Emballage-cadeau',
        bagFee: 'Frais de sac',
        specialFee: 'Frais spécial',
        gstOrHst: 'TPS/TVH',
        pst: 'TVP',
        tax: 'Taxe',
        storeCreditRedeemed: 'Crédit au compte',
        giftCardRedeemed: 'Carte-cadeau utilisée',
        eGiftCardRedeemed: 'Carte-cadeau électronique utilisée'
    };

    return resources[label];
};
